import { render } from "./BackCustomBtn.vue?vue&type=template&id=4f1b188f&scoped=true"
import script from "./BackCustomBtn.vue?vue&type=script&lang=js"
export * from "./BackCustomBtn.vue?vue&type=script&lang=js"

import "./BackCustomBtn.vue?vue&type=style&index=0&id=4f1b188f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f1b188f"]])

export default __exports__